import React from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import { PortionChart } from 'shared/components';

export default function IrPortion({ invested, budget }) {
  const contributed = budget > 0 ? Math.min((invested / budget) * 100, 100) : 0;

  const data = [
    { name: 'Contributed', value: contributed, color: '#62C760' },
    { name: 'Budget', value: 100 - contributed, color: '#EBF1F7' },
  ];

  return (
    <Container>
      <Table>
        <Heading>
          <h2>Portion Contributed</h2>
          <TableRow>
            <Col><PortionChart data={data} /></Col>
            <Col>
              <Title>Contribution:</Title>
              <Amount>{`$${numeral(invested).format('0,0')}`}</Amount>
              <Title style={{marginTop: '20px'}}>Budget:</Title>
              <Amount>{`$${numeral(budget).format('0,0')}`}</Amount>
            </Col>
          </TableRow>
        </Heading>
      </Table>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  height: 100%;
`;
const Table = styled.div`
  width: 100%;
  height: 100%;
  min-height: 200px;
  background-color: #FFFFFF;
  border: solid 1px #ccd7e3;
  border-radius: 4px;
  padding-bottom: 20px; 
`;
const Heading = styled.div`
  padding: 20px;
  padding-bottom: 0px;
  h2 {
    color: #595959;
    font-size: 24px;
    font-weight: 700;
  }
`;
const TableRow = styled.div`
  width: 100%;
  height: auto;
  padding: 20px;
  display: flex;
  flex-direction: row;
`;
const Col = styled.div`
  flex: 1;
`;
const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
`;
const Amount = styled.div`
  font-size: 28px;
  font-weight: bold;
  color: #778CA6;
`;